import React from 'react'
import bg from '../../assets/video-background.png'
import { Col, Row } from 'react-bootstrap'
import { Play } from 'lucide-react'

const Competitors = ({ t }) => {

    return (
        <section className='py-5 d-none d-md-block'>
            <Row className='justify-content-center'>
                <Col xl="12">
                    <div className='position-relative'>
                        <img src={bg} width="100%" height="100%" alt='Illustration' className='rounded-4' />
                        <div className='position-absolute w-100 h-100 top-0 start-0 rounded-4'>
                            <div className='d-flex flex-column justify-content-between h-100 p-5 text-white'>
                                <div className='fw-medium text-start' style={{ fontSize: '280%', color: 'white' }} dangerouslySetInnerHTML={{ __html: t('competitors_text') }}></div>

                                <div className='align-self-center bg-white bg-opacity-25 d-flex justify-content-center align-items-center rounded-circle text-white' style={{ width: "90px", height: "90px", minWidth: "90px", maxWidth: "90px", minHeight: "90px", maxHeight: "90px" }}>
                                    <Play size={30} strokeWidth={1.5} />
                                </div>

                                <div className='mt-5 d-flex align-items-center gap-1 fs-5'>
                                    <span>
                                        {t('read_more_stories')}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default Competitors
